import { animated, useTrail } from "react-spring";

import HorizontalThumbnail from "../HorizontalThumbnail";
import { HorizontalThumbnailProps } from "../HorizontalThumbnail/HorizontalThumbnail";
import React from "react";

export interface HorizontalThumbnailGridProps {
  items: HorizontalThumbnailProps[];
}

const HorizontalThumbnailGrid = ({ items }: HorizontalThumbnailGridProps) => {
  // Fade in up animation
  const fadeInUpTrail = useTrail(items.length, {
    opacity: 1,
    transform: "translateY(0px)",
    from: {
      opacity: 0,
      transform: "translateY(10px)",
    },
  });

  return (
    <div className="flex flex-wrap justify-start w-full">
      {items.length ? (
        items.map((item, key) => (
          <animated.div
            className="w-full px-2 py-6 lg:w-4/12 xl:w-3/12"
            style={fadeInUpTrail[key]}
            key={key}
          >
            <HorizontalThumbnail {...item} />
          </animated.div>
        ))
      ) : (
        <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
          No items available.
        </div>
      )}
    </div>
  );
};

export default HorizontalThumbnailGrid;
